/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore'

export default function (self) {
  /*
   * @namespace Model
   * @mixin
   *
   */
  return {
    fullName (options) {
      if (options == null) { options = {} }
      const names = _.compact([this.get('first_name'), this.get('last_name')])

      if (!names.length) {
        return this.get('email') || 'Unregistered'
      } else {
        let delimeter
        if (names.length === 1) {
          delimeter = ''
        } else {
          delimeter = options.delimeter || ' '
          if (options.reverse) { names.reverse() }
        }

        return names.join(delimeter)
      }
    }
  }
}
